import React from 'react';
import './BarMenuListItemDetail.scss';

const decimalToFraction = (input) => {
  if (input === null || input === undefined || input === '') return '';
  const num = Number(input);
  if (Number.isNaN(num)) return input;

  const fractions = {
    '0.25': '¼',
    '0.33': '⅓',
    '0.5': '½',
    '0.66': '⅔',
    '0.75': '¾',
    '1.25': '1¼',
    '1.33': '1⅓',
    '1.5': '1½',
    '1.66': '1⅔',
    '1.75': '1¾',
    '2.25': '2¼',
    '2.33': '2⅓',
    '2.5': '2½',
    '2.66': '2⅔',
    '2.75': '2¾'
  };

  const key = num.toFixed(2);
  return fractions[key] || (Number.isInteger(num) ? String(num) : String(num));
};

const highlightKeyWord = (string) => {
  return string.split(' ').map((word, i) => {
    if (word === word.toUpperCase() && word.match(/[A-Z]/)) {
      return <span>{word} </span>;
    }
    return word + ' ';
  });
};

const BarMenuListItemDetail = (props) => (
  <div className={`fullscreen_overlay${props.visible ? ' visible' : ''}`}>
    <div class="overlay_wrapper fixed_width">
      <div class="close-btn" onClick={props.handleCloseOverlay}><span></span><span></span></div>
      <div class="overlay_content">
        <h2>{props.selectedRecipe.title}</h2>
        <div class="seperator"></div>
        <div>
          <div>
            <ul>
              {props.selectedRecipe.ingredients.map((ing, i) => (
                <li key={i}>
                   {ing.amount !== 0 && <span>{decimalToFraction(ing.amount)}</span>}
                   {ing.unit !== "" && <span>{ing.unit}</span>}
                  {ing.ingredient}
                </li>
              ))}
            </ul>
          </div>
          <p class="simple_text">{highlightKeyWord(props.selectedRecipe.instructions)}</p>
        </div>
      </div>
    </div>
    <div class="bg" onClick={props.handleCloseOverlay}></div>
  </div>
);

export default BarMenuListItemDetail;
